exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.layout-remove-config-dialog .remove-config-footer[data-v-10ff8477] {\n  text-align: right;\n  margin-top: 30px;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/layout/components/remove-config-dialog.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,iBAAiB;CAClB","file":"remove-config-dialog.vue","sourcesContent":["\n.layout-remove-config-dialog .remove-config-footer[data-v-10ff8477] {\n  text-align: right;\n  margin-top: 30px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10ff8477","scoped":true,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/components/remove-config-dialog.vue
// module id = KLOU
// module chunks = 7